import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import classNames from 'classnames';
import { tuple } from '../_utils/type';
import isArray from 'lodash/isArray';
import isBoolean from 'lodash/isBoolean';
import devwarning from '../_utils/devwarning';
export var IconPositionTypes = tuple('left', 'right');
var NONE_KEY = undefined;
var InternalCollapse = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      prefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps;

  var _getCompProps = getCompProps('Collapse', userDefaultProps, props),
      accordion = _getCompProps.accordion,
      activeKey = _getCompProps.activeKey,
      bordered = _getCompProps.bordered,
      defaultActiveKey = _getCompProps.defaultActiveKey,
      expandIcon = _getCompProps.expandIcon,
      expandIconPosition = _getCompProps.expandIconPosition,
      onChange = _getCompProps.onChange,
      style = _getCompProps.style,
      className = _getCompProps.className,
      children = _getCompProps.children,
      customPrefixcls = _getCompProps.prefixCls;

  var CollapsePrefixCls = getPrefixCls(prefixCls, 'collapse', customPrefixcls); // 样式前缀

  var getDefaultActivePanelKey = function getDefaultActivePanelKey() {
    // const _defaultActiveKey =
    //   defaultActiveKey !== NONE_KEY
    //     ? defaultActiveKey
    //     : React.Children.map(children, (item, index) => {
    //         if (index === 0) return item.props?.panelKey
    //       })
    // return isBoolean(activeKey) ? activeKey : _defaultActiveKey
    return isBoolean(activeKey) ? activeKey : defaultActiveKey;
  };

  var _React$useState = React.useState(getDefaultActivePanelKey()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activePanelKey = _React$useState2[0],
      setActivePanelKey = _React$useState2[1];

  var getPanelExpand = function getPanelExpand(panelKey, accordion, activeKey) {
    var _activeKey = getActiveKey(accordion, activeKey);

    return isInclude(_activeKey, panelKey);
  };

  var getActiveKey = function getActiveKey(accordion, activeKey) {
    var _activeKey = activeKey;

    if (accordion) {
      if (isArray(activeKey)) {
        _activeKey = activeKey[0]; // accordion 模式下默认第一个元素
      }
    }

    return _activeKey;
  };

  var isInclude = function isInclude(activePanelKey, key) {
    if (isArray(activePanelKey)) {
      return _includesInstanceProperty(activePanelKey).call(activePanelKey, key) || _includesInstanceProperty(activePanelKey).call(activePanelKey, String(key));
    } else {
      return String(activePanelKey) === String(key);
    }
  };

  var getRemoveKey = function getRemoveKey(key) {
    if (isArray(activePanelKey)) {
      return _filterInstanceProperty(activePanelKey).call(activePanelKey, function (element) {
        return element !== key;
      });
    }

    return NONE_KEY;
  };

  var getAddKey = function getAddKey(key) {
    if (isArray(activePanelKey)) {
      var _context;

      return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(activePanelKey), [key]);
    }

    return activePanelKey ? [activePanelKey, key] : key;
  };

  var getNewActiveKey = function getNewActiveKey(key) {
    if (isInclude(activePanelKey, key)) {
      if (accordion) {
        return NONE_KEY;
      }

      return getRemoveKey(key);
    } else {
      if (accordion) {
        return key;
      }

      return getAddKey(key);
    }
  };

  var onPanelChange = React.useCallback(function (key) {
    key = getNewActiveKey(key);
    setActivePanelKey(key);
    onChange && onChange();
  }, [onChange, activePanelKey, accordion]);

  var renderPanel = function renderPanel() {
    var _context2;

    return _mapInstanceProperty(_context2 = React.Children).call(_context2, children, function (item) {
      var _a, _b, _c;

      if (((_a = item === null || item === void 0 ? void 0 : item.type) === null || _a === void 0 ? void 0 : _a.displayName) !== 'Panel') {
        devwarning(true, 'Collapse', 'children必须为Collapse.Panel');
        return item;
      }

      var expand = getPanelExpand((_b = item.props) === null || _b === void 0 ? void 0 : _b.panelKey, accordion, activePanelKey);
      var defaultExpand = getPanelExpand((_c = item.props) === null || _c === void 0 ? void 0 : _c.panelKey, accordion, defaultActiveKey);
      return /*#__PURE__*/React.cloneElement(item, _extends({
        expandIcon: expandIcon,
        expandIconPosition: expandIconPosition,
        onChange: onPanelChange,
        bordered: bordered,
        expand: expand,
        defaultExpand: defaultExpand
      }, item.props));
    });
  };

  var rootClassName = classNames(className, _defineProperty({}, "".concat(CollapsePrefixCls), true));
  var collapseRef = ref || /*#__PURE__*/React.createRef();
  return /*#__PURE__*/React.createElement("div", {
    className: rootClassName,
    style: style,
    ref: collapseRef
  }, renderPanel());
});
InternalCollapse.displayName = 'Collapse';
export default InternalCollapse;